import { QueryFeature } from '../../../../../../../../config/queryClient';

enum QueryKey {
  EstatePlanningFlowChart = 'EstatePlanningFlowChart',
}

export const queryKeys = {
  estatePlanningFlowChart: ({
    clientId,
    fpId,
    isSpouse,
  }: {
    clientId: number;
    fpId: string;
    isSpouse?: boolean;
  }) => [QueryFeature.EstatePlanning, QueryKey.EstatePlanningFlowChart, clientId, fpId, isSpouse],
};
